import React, { useState } from 'react';
import { Sling as Hamburger } from 'hamburger-react';
import { Link } from 'react-router-dom';


const Navbar = (props) => {
    const [isNavOpen, setNavOpen] = useState(false);

    return(
        <header className='flex justify-center items-center w-screen fixed top-0 left-0 z-20'>
            <nav className='flex justify-between items-center ml-5 mr-5 w-full h-16 max-w-5xl'>
                <Link to='/' className="navlogo">{`< Decodam / >`}</Link>

                <div className="navlist sm:hidden">
                    <Link to="/" className='text-gray-400 hover:text-gray-200 transition ml-8' >.home</Link>
                    <Link to="/about" className='text-gray-400 hover:text-gray-200 transition ml-8' >.about</Link>
                    <Link to="/projects" className='text-gray-400 hover:text-gray-200 transition ml-8' >.projects</Link>
                    <Link to="/#contact" className='text-gray-400 hover:text-gray-200 transition ml-8' >.contact</Link>
                </div>

                <div 
                    onClick={() => {if(isNavOpen){setNavOpen(false)}else{setNavOpen(true)}}} 
                    className={isNavOpen ?  "navResplist openlist backdrop-blur-lg sm:flex hidden" :  "navResplist backdrop-blur-lg sm:flex hidden"}
                >
                    <Link to="/" className='text-gray-400 text-3xl transition m-4' >{`>.`}Home</Link>
                    <Link to="/about" className='text-gray-400 text-3xl transition m-4' >{`>.`}About</Link>
                    <Link to="/projects" className='text-gray-400 text-3xl transition m-4' >{`>.`}Projects</Link>
                    <Link to="/#contact" className='text-gray-400 text-3xl transition m-4' >{`>.`}Contact</Link>
                </div>

                <div className="navbtn hidden sm:block">
                    <Hamburger toggled={isNavOpen} size={18} color='#999' toggle={setNavOpen} />
                </div>
            </nav>
        </header>
    );
}


export default Navbar;